module.exports = __webpack_public_path__ + "img/jrcode@2x.1df55314.png";